// control layout base on role, permission.
import { userManagement } from './user-management';
import { itemSharing } from './item-sharing';
import { messaging } from './messaging';
import { foodDelivery } from './food-delivery';
import { news } from './news';
import { privilege } from './privilege';
import { docs } from './docs';
import { summary } from './summary';
import { reward } from './reward';
import { apps } from './apps';
import { apps2 } from './apps2';
import { shops } from './101-shops';
import { zones } from './101-zones';
import { categories } from './101-categories';
import { floors } from './101-floors';
import { announcement } from './announcemnet';
import { jwt } from './jwt';
import { oneAppMessaging } from './one-app-messaging';
import { oneAppProfiles } from './one-app-profiles';
import { oneAppResidents } from './one-app-residents';
import { oneAppProjects } from './one-app-projects';

const home = [
  {
    name: 'App Store',
    url: '/apps',
    icon: 'fa fa-tablet'
  },
  {
    title: true,
    name: 'Server Status'
  },
  {
    name: 'Development',
    url: '#development',
    label: {
      class: 'text-success'
    }
  },
  {
    name: 'Staging',
    url: '#staging',
    label: {
      class: 'text-info'
    }
  },
  {
    name: 'Production',
    url: '#production',
    label: {
      class: 'text-info'
    }
  }
];

export const nav = {
  home: home,
  userManagement: userManagement,
  itemSharing: itemSharing,
  messaging: messaging,
  foodDelivery: foodDelivery,
  news: news,
  privilege: privilege,
  docs: docs,
  summary: summary,
  reward: reward,
  apps: apps,
  apps2: apps2,
  '101shops': shops,
  '101zones': zones,
  '101categories': categories,
  '101floors': floors,
  announcement: announcement,
  jwt: jwt,
  'one_app_messaging': oneAppMessaging,
  'one_app_profiles': oneAppProfiles,
  'one_app_residents': oneAppResidents,
  'one_app_projects': oneAppProjects
};
